import {
    faPlus,
    faStepBackward,
    faStepForward,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm, FormProvider } from "react-hook-form";
import { useRegistrarAcordoContext } from "..";
import LazySelect from "../../../../../Components/CardsPages/Forms/LazySelect";
import Table from "../../../../../Components/Table";
import { IParcelaModelo } from "../../../../../Interfaces/Cobranca/Renegociacao/ModeloRenegociacao/ModeloRenegociacaoInterface";
import { IParcelaModeloEditavel } from "../../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { comparaDatasDia } from "../../../../../Validations/DateValidation";
import IndicadoresDeValor from "../IndicadoresDeValor";
import ParcelaModelo from "./ParcelaModelo";
import { MoneyReaisFieldMask } from "../../../../../Validations/InputMasks";
interface ICarregarParcelasModeloFormData {
    idModelo: number;
    DiaPrimeiraParc: number;
    ValorEntrada?: string;
    DataVencimentoEntrada?: string;
}
interface IParcelasModeloFormData {
    parcelas: {
        [index: string]: IParcelaModeloEditavel;
    };
}

export default function EscolhaDeModelo() {
    const {
        modelos,
        goToStep,
        calculoNovoFluxoRequest,
        calcularNovoFluxo,
        setDiaEEntrada,
        valoresFluxo,
        setValoresFluxo,
        indicadores,
    } = useRegistrarAcordoContext();

    const { register, handleSubmit, getValues, setValue } =
        useForm<ICarregarParcelasModeloFormData>();
    const parcelasForm = useForm<IParcelasModeloFormData>();

    const [dataVencimento, setDataVencimento] = useState<string>(
        new Date().toISOString().substring(0, 10)
    );
    const [selecionarDia, setSelecionarDia] = useState<number | null>(null);

    const gerarOpcoesDia = () => {
        const date = new Date(dataVencimento);
        const daysInMonth = new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0
        ).getDate();
        return Array.from({ length: daysInMonth }, (_, index) => index + 1);
    };
    const [lstParcelasModelo, setLstParcelasModelo] = useState(
        calculoNovoFluxoRequest.current?.parcelas ??
            ([] as Array<IParcelaModelo>)
    );
    const [loading, setLoading] = useState(false);
    const [valorEntrada, setValorEntrada] = useState(0);

    const [valorTotal, setValorTotal] = useState(0);
    const [somaPrclsTotal, setSomaPrclsTotal] = useState(0);

    const handleCarregarParcelasModeloFormSubmit = (
        formData: ICarregarParcelasModeloFormData
    ) => {
        setLoading(true);
        modelos
            .getParcelasModelo(
                formData.idModelo,
                formData.DiaPrimeiraParc,
                Number(
                    formData?.ValorEntrada?.replace("R$", "")
                        .replace(".", "")
                        .replace(",", ".")
                        .trim()
                ),
                formData?.DataVencimentoEntrada
            )
            .then((res) => {
                setDiaEEntrada({
                    DataVencimentoEntrada: formData?.DataVencimentoEntrada,
                    DiaPrimeiraParc: formData.DiaPrimeiraParc,
                    ValorEntrada: Number(
                        formData?.ValorEntrada?.replace("R$", "").replace(
                            ",",
                            "."
                        )
                    ),
                });
                setLstParcelasModelo(res ?? []);
                setValoresFluxo(res?.map((response) => response.valorFluxo));
            })
            .finally(() => setLoading(false));
    };

    const handleParcelasModeloFormSubmit = (
        formData: IParcelasModeloFormData
    ) => {
        if (lstParcelasModelo) {
            // variável para controlar se os dados atuais são novos
            let diff = false;
            let algumaRetroativa = false;
            const { idModelo, DiaPrimeiraParc, ValorEntrada } = getValues([
                "idModelo",
                "DiaPrimeiraParc",
                "ValorEntrada",
            ]);

            //merge lstParcelas com dados do formulário
            lstParcelasModelo.forEach((p, index) => {
                const formParcela = formData.parcelas[`p${p.Num_MvPar}`];
                // validação para ver se houve mudança de valores
                diff =
                    diff ||
                    formParcela?.Qtde_MvPar !== p.Qtde_MvPar ||
                    formParcela.dataPrimeiraParcela !== p.dataPrimeiraParcela ||
                    formParcela.ValorEntrada !== p.ValorEntrada;

                if (formParcela && formParcela.Qtde_MvPar)
                    p.Qtde_MvPar = formParcela.Qtde_MvPar;
                if (formParcela && formParcela.dataPrimeiraParcela)
                    p.dataPrimeiraParcela = formParcela.dataPrimeiraParcela;
                if (formParcela && formParcela.dataPrimeiraParcela) {
                    p.ValorEntrada = Number(
                        ValorEntrada?.replace("R$", "")
                            .replace(".", "")
                            .replace(",", ".")
                            .trim()
                    );
                    p.valorFluxo = Number(valoresFluxo?.[index]);
                }
            });
            if (valoresFluxo) {
                const novosValores = [...valoresFluxo];
                setValoresFluxo(novosValores);

                const somaParcelas = novosValores
                    .reduce((acc, valor) => acc + (valor || 0), 0)
                    .toFixed(2);

                setSomaPrclsTotal(Number(somaParcelas));
            }
            if (!algumaRetroativa) {
                calcularNovoFluxo(
                    lstParcelasModelo,
                    idModelo,
                    DiaPrimeiraParc,
                    Number(
                        ValorEntrada?.replace("R$", "")
                            .replace(".", "")
                            .replace(",", ".")
                            .trim()
                    ),
                    diff
                );
                if (valoresFluxo) {
                    const novosValores = [...valoresFluxo];
                    setValoresFluxo(novosValores);

                    const somaParcelas = novosValores
                        .reduce((acc, valor) => acc + (valor || 0), 0)
                        .toFixed(2);

                    setSomaPrclsTotal(Number(somaParcelas));
                }
                goToStep("novoFluxo");
                if (valoresFluxo) {
                    const novosValores = [...valoresFluxo];
                    setValoresFluxo(novosValores);

                    const somaParcelas = novosValores
                        .reduce((acc, valor) => acc + (valor || 0), 0)
                        .toFixed(2);

                    setSomaPrclsTotal(Number(somaParcelas));
                }
            }
        }
    };

    //Table
    const columns: Array<ColumnDescription> = [
        {
            dataField: "Num_MvPar",
            text: "Parcelas",
            formatter: (_c, row) => <ParcelaModelo parcela={row} />,
        },
    ];
    const columnsTableView: Array<ColumnDescription<IParcelaModelo>> = [
        {
            dataField: "Parcelas",
            text: "Tipo de Parcela",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
        },
        {
            dataField: "Qtde_MvPar",
            text: "Quantidade de Parcelas",
            formatter: (cell, row) => {
                return (
                    <input
                        className="form-control"
                        name={`parcelas.p${row.Num_MvPar}.Qtde_MvPar`}
                        ref={parcelasForm.register({
                            valueAsNumber: true,
                        })}
                        defaultValue={cell}
                        type="number"
                    />
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "dataPrimeiraParcela",
            text: "Vencimento 1ª Parcela",
            formatExtraData: parcelasForm.formState.errors,
            formatter: (cell: string, row, _, errors) => {
                return (
                    <input
                        type="date"
                        className={`form-control ${
                            errors.parcelas?.[`p${row.Num_MvPar}`]
                                ?.dataPrimeiraParcela
                                ? " is-invalid"
                                : ""
                        }`}
                        name={`parcelas.p${row.Num_MvPar}.dataPrimeiraParcela`}
                        ref={parcelasForm.register({
                            validate: (date) =>
                                comparaDatasDia(
                                    new Date(`${date}T23:59Z`),
                                    new Date()
                                )
                                    ? true
                                    : "Data Retroativa!",
                        })}
                        defaultValue={cell?.substr(0, 10)}
                    />
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "tipoFluxo",
            text: "Tipo de Fluxo",
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "valorFluxo",
            text: "Valor do Fluxo",
            formatter: (cell, row, index, errors) => {
                const total = indicadores?.VL_TOTAL.toFixed(2) ?? 0;

                setValorTotal(Number(total));

                if (valoresFluxo) {
                    const novosValores = [...valoresFluxo];
                    setValoresFluxo(novosValores);
                    const somaParcelas = novosValores
                        .reduce((acc, valor) => acc + (valor || 0), 0)
                        .toFixed(2);
                    setSomaPrclsTotal(Number(somaParcelas));
                }
                return (
                    <input
                        type="text"
                        className={`form-control`}
                        onChange={(e) => {
                            const newValue = MoneyReaisFieldMask(e);

                            if (valoresFluxo) {
                                setValoresFluxo((prevState) => {
                                    const novosValores = [...(prevState || [])];
                                    novosValores[index] = Number(
                                        MoneyReaisFieldMask.unMask(newValue) ||
                                            0
                                    );
                                    const somaParcelas = novosValores
                                        .reduce(
                                            (acc, valor) => acc + (valor || 0),
                                            0
                                        )
                                        .toFixed(2);

                                    setSomaPrclsTotal(parseFloat(somaParcelas));
                                    return novosValores;
                                });
                            }
                        }}
                        defaultValue={formatMoneyReais(
                            valoresFluxo?.[index] ?? 0
                        )}
                    />
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
    ];
    return (
        <div>
            <IndicadoresDeValor />
            <h3 className="mt-5">Renegociação de parcelas</h3>
            <form
                className="row mb-5"
                onSubmit={handleSubmit(handleCarregarParcelasModeloFormSubmit)}
            >
                <div className="col-12 col-md-8 col-xl-6">
                    <LazySelect
                        controller={modelos.getModelos}
                        name="idModelo"
                        ref={register({
                            required: "Insira o modelo de renegociação",
                        })}
                        getDS={(m) => m.Descricao_Mven}
                        getKeyValue={(m) => m.Num_Mven}
                        setValue={setValue}
                        defaultValue={
                            calculoNovoFluxoRequest.current?.request.idModelo
                        }
                        label="Modelo de Renegociação"
                        className="form-control"
                    />
                </div>
                <div className="col-12 col-md-4 col-xl-2">
                    <label>Valor de entrada:</label>
                    <input
                        name="ValorEntrada"
                        className="form-control"
                        value={formatMoneyReais(valorEntrada)}
                        onChange={(e) => {
                            MoneyReaisFieldMask(e);
                            setValorEntrada(
                                Number(
                                    MoneyReaisFieldMask.unMask(e.target.value)
                                )
                            );
                        }}
                        ref={register({
                            required: "Insira um valor de entrada",
                        })}
                    />
                </div>
                <div className="col-12 col-md-4 col-xl-2">
                    <label>Data de Vencimento:</label>
                    <input
                        type="date"
                        name="DataVencimentoEntrada"
                        ref={register()}
                        className="form-control px-0 p-2 placeholder-dark-75"
                        onChange={(e) => setDataVencimento(e.target.value)}
                        value={dataVencimento}
                    />
                </div>
                <div className="col-12 col-md-4 col-xl-2">
                    <label>Parcelas todo dia:</label>
                    <select
                        name="DiaPrimeiraParc"
                        ref={register()}
                        value={selecionarDia || ""}
                        onChange={(e) =>
                            setSelecionarDia(parseInt(e.target.value) || null)
                        }
                        defaultValue={
                            calculoNovoFluxoRequest.current?.request
                                .DiaPrimeiraParc
                        }
                        className="form-control"
                    >
                        <option value="">Selecione o dia</option>
                        {gerarOpcoesDia().map((dia) => (
                            <option key={dia} value={dia}>
                                {dia}
                            </option>
                        ))}
                    </select>
                </div>
                {/* <div className="col-12 col-md-4 col-xl-2">
                    <label>Valor de Entrada Custas:</label>
                    <input
                        name="ValorEntrada"
                        className="form-control"
                        value={formatMoneyReais(valorEntrada)}
                        onChange={(e) => {
                            MoneyReaisFieldMask(e);
                            setValorEntrada(
                                Number(
                                    MoneyReaisFieldMask.unMask(e.target.value)
                                )
                            );
                        }}
                        ref={register({
                            required: "Insira um valor de entrada",
                        })}
                    />
                </div>
                <div className="col-12 col-md-4 col-xl-2">
                    <label>Data de Vencimento Custas:</label>
                    <input
                        type="date"
                        name="DataVencimentoEntrada"
                        ref={register()}
                        className="form-control px-0 p-2 placeholder-dark-75"
                        onChange={(e) => setDataVencimento(e.target.value)}
                        value={dataVencimento}
                    />
                </div> */}
                <div className="col-12 mt-4">
                    <button className="w-100 btn btn-primary">
                        Carregar Modelo
                    </button>
                </div>
            </form>

            <div>
                {lstParcelasModelo && (
                    <FormProvider {...parcelasForm}>
                        <div className="w-100 d-flex justify-content-end my-4">
                            <button className="btn btn-success mr-2">
                                Adicionar <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div>
                        <form
                            id="form-parcelas-modelo"
                            onSubmit={parcelasForm.handleSubmit(
                                handleParcelasModeloFormSubmit
                            )}
                        >
                            {valoresFluxo?.length !== 0 && (
                                <>
                                    <Table
                                        data={lstParcelasModelo}
                                        columns={columns}
                                        keyField="Num_MvPar"
                                        bordered={false}
                                        rowClasses="border-bottom border-gray checkbox-table"
                                        sizePerPage={lstParcelasModelo.length}
                                        loading={loading}
                                        tableView={{
                                            columns: columnsTableView,
                                            // dando unregister para não ter problemas na troca de contexto tablecard
                                            onViewChange: () => {
                                                lstParcelasModelo.forEach(
                                                    (p) => {
                                                        parcelasForm.unregister(
                                                            [
                                                                `parcelas.p${p.Num_MvPar}.Qtde_MvPar`,
                                                                `parcelas.p${p.Num_MvPar}.dataPrimeiraParcela`,
                                                                `parcelas.p${p.Num_MvPar}.ValorEntrada`,
                                                            ]
                                                        );
                                                    }
                                                );
                                            },
                                        }}
                                        wrapperClasses="y-scroll maxHeight-300 mb-2"
                                        noPagination
                                        noSearch
                                    />
                                    {valorTotal !== somaPrclsTotal && (
                                        <div className="text-right">
                                            <span className="text-danger">
                                                A soma dos valores do fluxo não
                                                coincide com o Valor Total
                                                esperado. Por favor, verifique e
                                                ajuste os valores.
                                            </span>
                                        </div>
                                    )}
                                </>
                            )}
                        </form>
                    </FormProvider>
                )}
            </div>

            <div className="d-flex justify-content-between mt-5">
                <button
                    className="btn btn-primary"
                    onClick={() => goToStep("selecDescontos")}
                >
                    <FontAwesomeIcon className="mr-2" icon={faStepBackward} />
                    Voltar
                </button>
                <button
                    disabled={
                        !lstParcelasModelo.length ||
                        valorTotal !== somaPrclsTotal
                    }
                    className="btn btn-primary"
                    type="submit"
                    form="form-parcelas-modelo"
                >
                    Simular Novo Fluxo
                    <FontAwesomeIcon className="ml-2" icon={faStepForward} />
                </button>
            </div>
        </div>
    );
}
